import { Record } from 'immutable';
import * as types from './actionTypes';
import constants from '../constants';

const requestReducerState = Record({
  allProviders: [],
  penConfig: {
    protectionPlanSource: null,
    providers: [],
    products: [],
    availableProductsForBundle: [],
    enableInUI: {
      products: true,
      bundles: true,
    },
    multiBundlesInDeal: false,
    productListFilter: null,
    showTotalCost: false,
    showDailyPrice: false,
    useSelectedOfferTermsAndMiles: false,
  },
  providerProducts: [],
  coverageNamesAndDeductibles: {},
  [constants.ERROR_KEY]: null,
  [constants.SUCCESS_KEY]: null,
  [constants.FETCHING_KEY]: false,
  [constants.FETCHING_COV_KEY]: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.PEN_REGISTER_SUCCESS:
    case types.EDIT_BUNDLE_SUCCESS:
    case types.CREATE_PRODUCT_SUCCESS:
    case types.DISABLE_PRODUCTS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false);
    case types.PROVIDERS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('allProviders', payload);
    case types.PROVIDER_PRODUCTS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('providerProducts', payload);
    case types.PRODUCTS_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('products', payload);
    case types.INIT_PEN_CONFIG_SUCCESS:
    case types.GET_AVAIL_PRODUCTS_FOR_BUNDLE_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('penConfig', payload);
    case types.SET_PEN_CONFIG_SUCCESS:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, false)
        .set('penConfig', { ...payload });
    case types.REGISTER_PRODUCT_AND_GET_COVERAGES_SUCCESS:
    case types.GET_COVERAGES_AND_DEDUCTIBLES_SUCCESS: {
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_COV_KEY, false)
        .set('coverageNamesAndDeductibles', payload.coverages);
    }
    case types.REGISTER_PRODUCT_AND_GET_COVERAGES_REQUEST:
    case types.INIT_PEN_CONFIG_REQUEST:
    case types.SET_PEN_CONFIG_REQUEST:
    case types.PROVIDERS_REQUEST:
    case types.PRODUCTS_REQUEST:
    case types.PROVIDER_PRODUCTS_REQUEST:
    case types.PEN_REGISTER_REQUEST:
    case types.EDIT_BUNDLE_REQUEST:
    case types.GET_AVAIL_PRODUCTS_FOR_BUNDLE_REQUEST:
    case types.DISABLE_PRODUCTS_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_KEY, true);
    case types.GET_COVERAGES_AND_DEDUCTIBLES_REQUEST:
      return state
        .set(constants.ERROR_KEY, null)
        .set(constants.FETCHING_COV_KEY, true);
    case types.REGISTER_PRODUCT_AND_GET_COVERAGES_FAILURE: {
      const coverageNamesAndDeductibles = state.get(
        'coverageNamesAndDeductibles',
      );
      coverageNamesAndDeductibles[payload.productId] = null;
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload.error)
        .set('coverageNamesAndDeductibles', coverageNamesAndDeductibles);
    }
    case types.INIT_PEN_CONFIG_FAILURE:
    case types.SET_PEN_CONFIG_FAILURE:
    case types.PROVIDERS_FAILURE:
    case types.PRODUCTS_FAILURE:
    case types.PROVIDER_PRODUCTS_FAILURE:
    case types.PEN_REGISTER_FAILURE:
    case types.EDIT_BUNDLE_FAILURE:
    case types.GET_AVAIL_PRODUCTS_FOR_BUNDLE_FAILURE:
    case types.DISABLE_PRODUCTS_FAILURE: {
      return state
        .set(constants.FETCHING_KEY, false)
        .set(constants.ERROR_KEY, action.payload);
    }
    case types.GET_COVERAGES_AND_DEDUCTIBLES_FAILURE: {
      return state
        .set(constants.FETCHING_COV_KEY, false)
        .set(constants.ERROR_KEY, action.payload)
        .set('coverageNamesAndDeductibles', {});
    }
    case types.RESET_COVERAGES_AND_DEDUCTIBLES: {
      return state.set('coverageNamesAndDeductibles', {});
    }
    default:
      return state;
  }
};
